import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Helmet } from "react-helmet";
import { useTranslation } from 'react-i18next';
import moment from "moment";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faDownload } from '@fortawesome/free-solid-svg-icons'
import { reloadPayments } from "../../actions/user";
import { downloadInvoice } from "../../dataProvider/invoice";
import "../../scss/v2/user/invoice.scss"

function Invoice(props) {

    const { t } = useTranslation();
    const [paymentsLoaded, setPaymentsLoaded] = useState(false);

    useEffect(() => {
        if (!paymentsLoaded) {
            props.dispatch(reloadPayments())
                .then(() => setPaymentsLoaded(true))
                .catch(console.error)
        }
    })

    return (
        <>
            <Helmet>
                <title>{t("meta.title.invoice")}</title>
                <meta name="description" content={t("meta.description.invoice")} />
            </Helmet>
            <div className="container invoice">
                <h1 className="invoice-title" >{t("invoice.title")}</h1>
                <p className="invoice-subtitle" >{t("invoice.subtitle")}</p>
                <div className="table-responsive-lg">
                    <table className="table invoice-table">
                        <thead>
                            <tr>
                                <th>{t('invoice.table.title.date')}</th>
                                <th>{t('invoice.table.title.amount')}</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            {props.payments.map((payment, key) => (<InvoiceRow payment={payment} key={key} user={props.user} />))}
                        </tbody>
                    </table>
                </div>
            </div>
        </>
    )

}

function InvoiceRow(props) {

    return (
        <tr>
            <td>{moment(props.payment.createdAt).format('DD/MM/YYYY')}</td>
            <td>{`${props.payment.isRefund ? '-' : ''}  ${props.payment.amount / 100} €`}</td>
            <td className="text-center" >
                <button className="invoice-button" onClick={() => downloadInvoice(props.user, props.payment)} >
                    <FontAwesomeIcon icon={faDownload} />
                </button>
            </td>
        </tr>
    );

}

const mapStateToProps = state => ({ payments: state.user.payments, user: state.user.user });

const mapDispatchToProps = dispatch => ({ dispatch })

export default connect(mapStateToProps, mapDispatchToProps)(Invoice);